export const enterKeyPressed = e => {
  return e.key === 'Enter';
};